export var TabContainerCssClass;
(function (TabContainerCssClass) {
    TabContainerCssClass["Base"] = "iress-tab-container";
    TabContainerCssClass["TabList"] = "iress-tab-container__tab-list";
    TabContainerCssClass["TopLeft"] = "iress-tab-container--top-left";
    TabContainerCssClass["TopCenter"] = "iress-tab-container--top-center";
    TabContainerCssClass["TopRight"] = "iress-tab-container--top-right";
})(TabContainerCssClass || (TabContainerCssClass = {}));
export var TabContainerLayout;
(function (TabContainerLayout) {
    TabContainerLayout["TopLeft"] = "top-left";
    TabContainerLayout["TopCenter"] = "top-center";
    TabContainerLayout["TopRight"] = "top-right";
})(TabContainerLayout || (TabContainerLayout = {}));
//# sourceMappingURL=tab-container.types.js.map